import React from 'react';

const InstagramStoriesAd = ({
  image,
  message,
  buttonText = 'Learn More',
  website = 'automateb.com',
}) => {
  const displayImage = image || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop';

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '260px',
        height: '460px',
        border: '1px solid #dee2e6',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        backgroundColor: '#000',
        position: 'relative',
      }}
    >
      {/* Blurred Background Image */}
      <img
        src={displayImage}
        alt="background blur"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(20px) brightness(0.6)',
          zIndex: 0,
          transform: 'scale(1.1)'
        }}
      />

      {/* Top Multi-segment Progress Bar */}
      <div style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        right: '10px',
        display: 'flex',
        gap: '4px',
        zIndex: 3
      }}>
        <div style={{ flex: 1, height: '2px', borderRadius: '1px', backgroundColor: 'rgba(255,255,255,0.8)' }} />
        <div style={{ flex: 1, height: '2px', borderRadius: '1px', backgroundColor: 'rgba(255,255,255,0.35)' }} />
      </div>

      {/* Top bar with logo and sponsored tag */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '20px 12px 10px 12px',
          justifyContent: 'space-between',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 2,
          color: 'white',
          fontSize: '0.7rem',
          fontWeight: 'bold',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
            alt="profile"
            style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              backgroundColor: 'white',
              objectFit: 'contain',
              border: '1.5px solid #fff'
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.1' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: '700', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>brightmediasolution</span>
            <span style={{ fontSize: '0.55rem', fontWeight: '500', opacity: 0.9, textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
              Sponsored
            </span>
          </div>
        </div>
        <button style={{ background: 'none', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer', padding: '0 4px', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
          ×
        </button>
      </div>

      {/* Foreground image (centered) */}
      <div
        style={{
          position: 'absolute',
          top: '48%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          height: '55%',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          borderRadius: '8px',
          overflow: 'hidden',
          backgroundColor: '#111'
        }}
      >
        <img
          src={displayImage}
          alt="Story Ad content"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Overlay with text and button at the bottom */}
      <div
        style={{
          position: 'absolute',
          bottom: '20px',
          left: 0,
          width: '100%',
          textAlign: 'center',
          color: 'white',
          zIndex: 2,
          padding: '0 16px'
        }}
      >
        {message && (
          <div style={{ 
            fontSize: '0.75rem', 
            marginBottom: '10px', 
            fontWeight: '600',
            textShadow: '0 2px 4px rgba(0,0,0,0.8)',
            backgroundColor: 'rgba(0,0,0,0.4)',
            padding: '6px 10px',
            borderRadius: '6px',
            display: 'inline-block',
            maxWidth: '90%'
          }}>
            {message}
          </div>
        )}
        <div style={{ fontSize: '0.625rem', marginBottom: '8px', opacity: 0.9, textTransform: 'lowercase', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
          {website}
        </div>
        <button
          style={{
            backgroundColor: 'white',
            color: '#000',
            border: 'none',
            borderRadius: '20px',
            padding: '8px 24px',
            fontWeight: '700',
            fontSize: '0.75rem',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          {buttonText || 'Learn More'}
          <i className="fa fa-chevron-up" style={{ fontSize: '0.6rem', marginTop: '1px' }} />
        </button>
      </div>
    </div>
  );
};

export default InstagramStoriesAd;

